// Opt-in Novel editor presentation. No changes to stored manuscripts, page IDs or editions.
export function childrensBookWriterPresentationV1({enabled = false, readOnly = false, pageConstrained = false} = {}) {
  return {
    disabled: readOnly === true,
    enableHighlight: enabled === true,
    enableWholeDocumentJustify: enabled === true,
    embeddedFlow: enabled === true && pageConstrained !== true,
    compactContinuousParagraphSpacing: enabled === true,
    boundedSurface: false,
  };
}
